import { Form, theme } from 'antd'
import React from 'react'

/**
 * Custom Form.Item yang mendukung wrapper div sebagai child
 * Menggunakan Form.Item dengan noStyle untuk wrapper styling, lalu Form.Item lagi di dalam untuk validasi
 * yang langsung wrap input component, dan wrapper div untuk styling visual
 */
const CustomFormItem = ({
  children,
  wrapper,
  containerStyle,
  childrenWrapper,
  ...formItemProps
}) => {
  const { token } = theme.useToken()

  // Jika ada wrapper, gunakan struktur dengan Form.Item noStyle untuk wrapper
  if (wrapper || containerStyle) {
    const { style, label, ...restProps } = formItemProps

    return (
      <Form.Item label={label} style={{ marginBottom: 24, ...style }}>
        <div
          style={{
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            // background: '#f5f5f5',
            border: `1px solid ${token.colorBorder}`,
            borderRadius: 6,
            padding: '0 12px',
            height: 48,
            ...containerStyle,
          }}
        >
          <div
            style={{
              order: 2,
              flex: 1,
              ...(childrenWrapper?.style || {}),
            }}
          >
            <Form.Item {...restProps} noStyle style={{ margin: 0 }}>
              {children}
            </Form.Item>
          </div>
          {wrapper}
        </div>
      </Form.Item>
    )
  }

  // Jika tidak ada wrapper, gunakan Form.Item biasa
  return <Form.Item {...formItemProps}>{children}</Form.Item>
}

export default CustomFormItem
